// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.disk_diskUsage__0jDIq {
  background-color: #555;
  color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 95%;
  margin: auto;
}

.disk_diskUsage__0jDIq h2 {
  text-align: center;
  color: #ffffff; /* 헤더 텍스트 색상 */
}

.disk_table__mbHU\\+ {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
.disk_table__mbHU\\+ tbody tr {
  transition: background-color 0.2s ease;
}
.disk_table__mbHU\\+ tbody tr:hover {
  background-color: #5a5a5a;
  cursor: pointer;
}

.disk_table__mbHU\\+ th,
.disk_table__mbHU\\+ td {
  padding: 10px;
  text-align: left;
  max-width: 150px; /* 각 셀의 최대 너비 설정 */
  word-wrap: break-word; /* 셀 안의 내용이 길면 줄바꿈 처리 */
  word-break: break-all; /* 단어가 길어지면 강제로 줄바꿈 */
}

.disk_table__mbHU\\+ th {
  background-color: #666;
}

.disk_disk_usage__7PGbi {
  width: 100px;
}

.disk_progressBarWrapper__HhmO\\+ {
  background-color: #333;
  border-radius: 5px;
  overflow: hidden;
  position: relative; /* 바 내부 텍스트 위치 조정 용이하게 설정 */
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center; /* 텍스트와 bar를 모두 중앙 정렬 */
}
.disk_progressBarWrapper__HhmO\\+ .disk_progressBar__FHKhc {
  height: 100%;
  position: absolute; /* 부모 요소 안에서 확장되도록 설정 */
  top: 0;
  left: 0;
  border-radius: 5px;
  transition: width 0.3s ease;
}
.disk_progressBarWrapper__HhmO\\+ .disk_progressText__LKZHT {
  position: relative; /* 텍스트는 부모 안에서 자유롭게 배치되도록 */
  width: 100%; /* 부모 요소만큼의 너비 차지 */
  text-align: center; /* 텍스트를 중앙에 위치시킴 */
  color: #fff;
  font-weight: bold;
  z-index: 1; /* bar 위에 텍스트가 표시되도록 */
}

.disk_disk_info_container__64YaJ {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #4a4535; /* 컨테이너 배경색 */
  color: #ffffff; /* 텍스트 색상 */
  padding: 20px;
  border-radius: 5px;
  width: 95%;
  margin: auto;
}

.disk_disk_info_container__64YaJ span {
  width: 100%;
}

.disk_disk_info_container__64YaJ h2 {
  text-align: center;
  color: #ffffff; /* 헤더 텍스트 색상 */
}

.disk_disk_info_box__7UsJE {
  background-color: #8baa46; /* 박스 배경색 */
  color: #ffffff; /* 텍스트 색상 */
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.disk_disk_info_box__7UsJE:hover {
  transform: scale(1.05);
}

.disk_disk_info_name__kPDoC {
  font-weight: bold;
  margin-bottom: 5px;
}

.disk_disk_info_size__SwTho {
  font-size: 1.2em;
}`, "",{"version":3,"sources":["webpack://./src/pages/Summary/disk/disk.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAEF;;AACA;EACE,kBAAA;EACA,cAAA,EAAA,cAAA;AAEF;;AACA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;AAEF;AAAI;EACE,sCAAA;AAEN;AAAM;EACE,yBAAA;EACA,eAAA;AAER;;AAIA;;EAEE,aAAA;EACA,gBAAA;EACA,gBAAA,EAAA,kBAAA;EACA,qBAAA,EAAA,uBAAA;EACA,qBAAA,EAAA,qBAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA,EAAA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA,EAAA,uBAAA;AADF;AAGE;EACE,YAAA;EACA,kBAAA,EAAA,uBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,2BAAA;AADJ;AAIE;EACE,kBAAA,EAAA,2BAAA;EACA,WAAA,EAAA,mBAAA;EACA,kBAAA,EAAA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA,EAAA,sBAAA;AAFJ;;AAOA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA,EAAA,aAAA;EACA,cAAA,EAAA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,kBAAA;EACA,cAAA,EAAA,cAAA;AAJF;;AAOA;EACE,yBAAA,EAAA,WAAA;EACA,cAAA,EAAA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0CAAA;EACA,0BAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAOA;EACE,iBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF","sourcesContent":[".diskUsage {\n  background-color: #555;\n  color: #fff;\n  padding: 20px;\n  border-radius: 5px;\n  width: 95%;\n  margin: auto;\n}\n\n.diskUsage h2 {\n  text-align: center;\n  color: #ffffff; /* 헤더 텍스트 색상 */\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  tbody {\n    tr {\n      transition: background-color 0.2s ease;\n      \n      &:hover {\n        background-color: #5a5a5a; // #555555와 #666666 사이의 더 연한 색상\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.table th,\n.table td {\n  padding: 10px;\n  text-align: left;\n  max-width: 150px; /* 각 셀의 최대 너비 설정 */\n  word-wrap: break-word; /* 셀 안의 내용이 길면 줄바꿈 처리 */\n  word-break: break-all; /* 단어가 길어지면 강제로 줄바꿈 */\n}\n\n.table th {\n  background-color: #666;\n}\n\n.disk_usage {\n  width: 100px;\n}\n\n.progressBarWrapper {\n  background-color: #333;\n  border-radius: 5px;\n  overflow: hidden;\n  position: relative; /* 바 내부 텍스트 위치 조정 용이하게 설정 */\n  width: 100%;\n  height: 20px;\n  display: flex;\n  align-items: center; /* 텍스트와 bar를 모두 중앙 정렬 */\n\n  .progressBar {\n    height: 100%;\n    position: absolute; /* 부모 요소 안에서 확장되도록 설정 */\n    top: 0;\n    left: 0;\n    border-radius: 5px;\n    transition: width 0.3s ease;\n  }\n\n  .progressText {\n    position: relative; /* 텍스트는 부모 안에서 자유롭게 배치되도록 */\n    width: 100%; /* 부모 요소만큼의 너비 차지 */\n    text-align: center; /* 텍스트를 중앙에 위치시킴 */\n    color: #fff;\n    font-weight: bold;\n    z-index: 1; /* bar 위에 텍스트가 표시되도록 */\n  }\n}\n\n// partition info 유지 - 이 부분은 변경하지 않음\n.disk_info_container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  background-color: #4a4535; /* 컨테이너 배경색 */\n  color: #ffffff; /* 텍스트 색상 */\n  padding: 20px;\n  border-radius: 5px;\n  width: 95%;\n  margin: auto;\n}\n\n.disk_info_container span {\n  width: 100%;\n}\n\n.disk_info_container h2 {\n  text-align: center;\n  color: #ffffff; /* 헤더 텍스트 색상 */\n}\n\n.disk_info_box {\n  background-color: #8baa46; /* 박스 배경색 */\n  color: #ffffff; /* 텍스트 색상 */\n  padding: 10px;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.disk_info_box:hover {\n  transform: scale(1.05);\n}\n\n.disk_info_name {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.disk_info_size {\n  font-size: 1.2em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"diskUsage": `disk_diskUsage__0jDIq`,
	"table": `disk_table__mbHU+`,
	"disk_usage": `disk_disk_usage__7PGbi`,
	"progressBarWrapper": `disk_progressBarWrapper__HhmO+`,
	"progressBar": `disk_progressBar__FHKhc`,
	"progressText": `disk_progressText__LKZHT`,
	"disk_info_container": `disk_disk_info_container__64YaJ`,
	"disk_info_box": `disk_disk_info_box__7UsJE`,
	"disk_info_name": `disk_disk_info_name__kPDoC`,
	"disk_info_size": `disk_disk_info_size__SwTho`
};
export default ___CSS_LOADER_EXPORT___;
